import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admins',
  templateUrl: './admins.component.html',
  styleUrls: ['./admins.component.css']
})
export class AdminsComponent implements OnInit {

  constructor(public service:AmbitService,
    public router: Router) { 
    if(this.service.adminUser.userAccess.admins =='None') {
      this.router.navigate(['/home']);
    }
  }

  ngOnInit() {
  }

}
